export default "__VITE_ASSET__DSsD7C1F__"